varying vec3 vPositionW;
varying vec3 vNormalW;

void main() {

  vPositionW  = (modelMatrix * vec4(position, 1.0)).xyz;
  vNormalW = normalize( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * normal );

  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);

} 